var exports = {
  "kL": "xdde3148b--8a4c74--container",
  "wx": "xdde3148b--8a4c74--header",
  "h_": "xdde3148b--8a4c74--description",
  "lu": "xdde3148b--8a4c74--expandable",
  "x6": "xdde3148b--8a4c74--button",
};

module.exports = exports;
